import FdCol from "./_col.vue";
import { pluginify } from "./../../util";
export default pluginify(FdCol);
export { default as Col } from "./_col.vue";
